import { useEffect, useState, useCallback } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import Record from 'src/components/inventoryManagement/Record';

import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import dayjs from 'dayjs';
import { FilterType } from 'src/components/inventoryManagement/TypeCustom';
import SearchData from 'src/components/inventoryManagement/SearchData';
import DialogDetail from 'src/components/inventoryManagement/Dialogdetail';

const currentDate = dayjs();

const breadcrumbsDefine = [
  {
    to: '/',
    label: '会計'
  },
  {
    label: '物販一覧'
  }
];
const defaultFilter = {
  month: currentDate.format('YYYY-MM'),
  product: ''
};

const InventoryMangement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [days, setDays] = useState<number[]>([]);
  const [months, setMonths] = useState<any[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [showDialogDetail, setShowDialogDetail] = useState(false);
  const [idInventory, setIdInventory] = useState(0);

  const handleCloseDialogDetail = () => {
    setShowDialogDetail(false);
  };

  const handleShowDialogDetail = useCallback((id: number) => {
    setIdInventory(id);
    setShowDialogDetail(true);
  }, []);

  const handleSearch = (filter: FilterType) => {
    getStock(filter);
  };

  const getStock = (filter: FilterType) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      const data = {
        minstock: false,
        month: filter.month !== null ? filter.month : currentDate.format('YYYY-MM'),
        page: 1,
        pagesize: 200,
        product: filter.product
      };

      setIsLoading(true);
      postAPI(`/master/stock-search?token=${token}`, data)
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setDays(res.data.days ? res.data.days : []);
            setMonths(res.data.months ? res.data.months : []);
            setProducts(res.data.products ? res.data.products : []);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  }

  useEffect(() => {
    getStock(defaultFilter);
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Typography
        component='label'
        sx={{
          fontWeight: '500',
          fontSize: '20px',
          lineHeight: '24px'
        }}
      >
        {'物販在庫管理'}
      </Typography>
      <Box
        sx={{
          mt: '18px'
        }}
      >
        <SearchData
          months={months}
          isLoading={isLoading}
          onClickSearch={handleSearch}
        />
      </Box>

      <Box sx={{
        mt: '27px'
      }}>
        {!isLoading ? (
          <Record
            items={products}
            headers={days}
            onClickRow={handleShowDialogDetail}
          />
        ) : (
          <Skeleton variant='rounded' width={'100%'} height={'calc(100vh - 240px)'} />
        )}
      </Box>

      <DialogDetail 
        open={showDialogDetail}
        id={idInventory}
        onClose={handleCloseDialogDetail}
      />
    </Box>
  );
}

export default InventoryMangement;